var site = site || {};

site.locator = site.locator || {};
site.locator.ui = site.locator.ui || {};
site.locator.data = site.locator.data || {};

site.locator.map = null; // Google map object
site.locator.mapDir = null; // Google map object
site.locator.markers = []; // Array of google.maps.marker objects, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.locationsHtml = []; // Array of HTML snippets for info windows, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.resultData = {}; // contains results from doors query. 
site.locator.resultData.results = []; // contains ordered results from doors query.
site.locator.infoWindow = null; // google.maps.InfoWindow object
site.locator.infoWindowDir = null; // google.maps.InfoWindow object
site.locator.queryFields = 'DOOR_ID, DOORNAME, EVENT_NAME, EVENT_START_DATE, EVENT_END_DATE, EVENT_IMAGE, EVENT_FEATURES, EVENT_TIMES, SERVICES, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY, REGION, COUNTRY, PHONE1';
site.locator.directionsDisplay = null; // google.maps.DirectionsRenderer object
site.locator.markerCounter = 0;
site.locator.unitOfMeasure = 'mile';

// site.locator.defaultCountry = 'United States';
site.locator.defaultCountries = '';
site.locator.queryArgs = '';

site.locator.ui.getRBs = function () {
  var rb = generic.rb('language');

  site.locator.rb = {
    view_details: rb.get('view_details'),
    store: rb.get('store'),
    address: rb.get('address'),
    phone: rb.get('phone'),
    event_js: rb.get('event_js'),
    search_results: rb.get('search_results'),
    no_criteria: rb.get('no_criteria'),
    search_error: rb.get('search_error'),
    select: rb.get('select')
  };
};

site.locator.getDomNodes = function () {
  site.locator.nodes = {
    moreResultsContainer: $('.more-results-container'),
    moreResultsButton: $('.more-results.button'),
    stateMenu: $('.state_container select'),
    countryMenu: $('select.country'),
    localcountryMenu: $('select.local_country'),
    cityMenuIntl: $('select.city_intl'),
    cityMenu: $('select.city'),
    doorMenu: $('select.door'),
    doorRows: [],
    doorWithEventRows: [],
    doorWithoutEventRows: [],
    searchInput: $('input.search_input'),
    distanceMenu: $('select.distance'),
    searchBtn: $('.search.button'),
    searchGeoBtn: $('.geo_search.button'),
    mapPanel: $('div.map_container'),
    closePanel: $('a.panel_close'),
    mapContainer: $('.map_container'),
    map: $('.map_canvas'),
    storeResults: $('div#store_results'),
    doorsBodySel: 'div.doors_body',
    // eventResults   : $('div#event_results'),
    locatorErrors: $('ul.locator_error_messages'),
    locatorErrors_intl: $('ul.locator_error_messages_intl'),
    dirAddrInput: $('div.directions_form input.address'),
    dirCityInput: $('div.directions_form input.city'),
    dirStateMenu: $('div.directions_form select.state'),
    dirDoorInput: $('div.directions_form input.door'),
    dirSubmit: $('div.directions_form a.directions_submit'),
    dirForm: $('div.directions_form'),
    dirResults: $('div.directions_results'),
    dirPanel: $('div.directions_panel'),
    dirMap: $('div.directions_map_container'),
    dirDestination: $('div.destination'),
    invalidZip: $('#locator-invalid-zip'),
    missingCityUS: $('#locator-missing-city-us'),
    missingCityIntl: $('#locator-missing-city-intl'),
    noLocationsFound: $('#no_locations_found'),
    localRegionIds: $('#region_ids'),
    intllocalRegionIds: $('#intl_region_ids'),
    stateContainer: $('.state_container'),
    localCountryContainer: $('.local_country_container'),
    errorNodes: $('ul.error_messages li', '.store-locator-mobile-v1'),
    cityLocalize: $('#city_localize'),
    locallanguage: $('#language_id'),
    errors: {
      noSearchTerm: $('ul.error_messages li.no-search-term'),
      noLocationsFound: $('ul.error_messages li.no-locations-found'),
      noStoresFound: $('ul.error_messages li.no-stores-found')
    }
  };
};

site.locator.ui.getTemplates = function () {
  var temp = {};

  generic.template.get({
    path: '/templates/locator/location_info.tmpl',
    callback: function () {},
    object: temp
  });
  generic.template.get({
    path: '/templates/locator/doors_table.tmpl',
    callback: function () {},
    object: temp
  });
  generic.template.get({
    path: '/templates/locator/door_row.tmpl',
    callback: function () {},
    object: temp
  });
};

/**
 * This function initializes the UI elements of the Store Locator page.
 * It communicates with site.locator.data via events.
 */
site.locator.ui.init = function () {
  if (typeof site.locator.locationData === 'undefined') {
    return;// no location data!
  }

  // set the default countries to the values passed by drupal
  site.locator.defaultCountries = $('#local_countries').val();

  site.locator.unitOfMeasure = $('#distance_type').val() || 'mile';

  /*
     * This function takes a select menu, removes its options, then adds an option with name="Default" and value = ""
     */
  var _clearMenu = function (menu) {
    // menu[0].options.length = 0;
    // wipe out menu html
		  menu.html('');
    // rebuild
    generic.forms.select.addOption({
      menuNode: menu,
      label: menu.attr('title') ? menu.attr('title') : site.locator.rb.select,
      value: ''
    });
  };
  /*
     * Initializes select menus by adding default option and populating the State menu from JSON data in page
     */
  var _initMenus = function () {
    // insert default options

    $([
      site.locator.nodes.countryMenu,
      site.locator.nodes.localcountryMenu,
		    site.locator.nodes.cityMenuIntl,
		    site.locator.nodes.stateMenu,
      site.locator.nodes.cityMenu,
      site.locator.nodes.doorMenu
    ]).each(function () {
      _clearMenu($(this));
    });

    // populate local country select first if visible

    for (var country in site.locator.locationData) {
      if (country == '') {
        continue;
      }

      if (site.locator.defaultCountries.indexOf(country) !== -1) {
        if (site.locator.nodes.stateContainer.hasClass('neither')) { // only showing city filter...
          for (var state in site.locator.locationData[country]) {
            // if ( state == "" ) { continue; }
            for (var city in site.locator.locationData[country][state]) {
              generic.forms.select.addOption({
                menuNode: site.locator.nodes.cityMenu,
                value: city
              });
            }
          }
        } else if (!site.locator.nodes.localCountryContainer.hasClass('state')) { // showing local country filter...
          generic.forms.select.addOption({
            menuNode: site.locator.nodes.countryMenu,
            value: country
          });
        } else { // showing state
          for (var state in site.locator.locationData[country]) {
            if (state == '') {
              continue;
            }
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.stateMenu,
              value: state
            });
          }
        }
      }
    }
    _refreshSelect($('.selectbox', site.locator.nodes.searchPanel));

    site.locator.nodes.countryMenu.val(site.locator.nodes.countryMenu.data('country-selected'));
  };
  var _localcountryMenuChangeHandler = function (stateNode, cityNode) {
    _clearMenu(stateNode);
    _clearMenu(cityNode);

    // populate state drop-down if visible, otherwise populate city drop-down
    if (!site.locator.nodes.stateContainer.hasClass('country')) {
      for (var state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
        if (state == '') {
          continue;
        }
        generic.forms.select.addOption({
          menuNode: stateNode,
          value: state
        });
      }
      stateNode.focus();
    } else {
      var cities = {};

      for (var state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
        jQuery.extend(cities, site.locator.locationData[site.locator.nodes.localcountryMenu.val()][state]);
      }
      _filterCityMenu(cityNode, cities);
      _sortSelect(cityNode);
      cityNode.focus();
    }
    _refreshSelect(stateNode);
    _refreshSelect(cityNode);
  };
  var _countryMenuChangeHandler = function (cityNode) {
    var cities = {};

    for (var state in site.locator.locationData[site.locator.nodes.countryMenu.val()]) {
      jQuery.extend(cities, site.locator.locationData[site.locator.nodes.countryMenu.val()][state]);
    }

    _filterCityMenu(cityNode, cities);
    cityNode.focus();
  };
  /*
     * Event handler for onchange event on State menu
     */
  var _stateMenuChangeHandler = function (cityNode, locationData) {
    _filterCityMenu(cityNode, locationData[site.locator.nodes.stateMenu.val()]);
    cityNode.focus();
  };
  /*
     * Reads value from state menu and populates city menu with the appropriate values, based on JSON data in page
     */
  var _filterCityMenu = function (cityNode, locationData) {
    _clearMenu(cityNode);
    // retrieve cities from that state, populate city menu
    var cityData = locationData;

    for (var city in cityData) {
      generic.forms.select.addOption({
        menuNode: cityNode,
        value: city
      });
    }
    _clearMenu(site.locator.nodes.doorMenu);
    _refreshSelect(cityNode);
  };
  /*
     * Sort select options in alphabetical order
     */
  var _sortSelect = function (selectNode) {
    var listitems = selectNode.children('option').get();

    listitems.sort(function (a, b) {
      return $(a).text().toUpperCase() === 'SELECT' ? -1 : $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
    });
    $.each(listitems, function (idx, itm) {
      selectNode.append(itm);
    });
  };
  /*
     * Event handler for onchange event on City menu
     */
  var _cityMenuChangeHandler = function (doorNode, locationData) {
    var state = site.locator.nodes.stateMenu.val();
    var city = site.locator.nodes.cityMenu.val();

    // _filterDoorMenu( doorNode, locationData[state][city] );
    doorNode.focus();
  };
  /*
     * Reads value from city menu and populates door (store) menu with the appropriate values, based on JSON data in page
     */
  var _filterDoorMenu = function (doorNode, locationData) {
    _clearMenu(doorNode);
    var storeArray = locationData;

    for (var i = 0, len = storeArray.length; i < len; i++) {
      generic.forms.select.addOption({
        menuNode: doorNode,
        value: storeArray[i]
      });
    }
  };
  // Take a url and then bitly it up and replace the facebook and twitter share links with it
  var _placeShareURL = function (shareURL) {
    window.shareURL = shareURL;
    _getBitly(shareURL, function (shortURL) {
      var encodedURL = encodeURIComponent(shortURL); // Not sure if I should use encodeURI, escape or encodeURIComponent here

      // This is a bit horrid. Set the bitly-ized url to share as a global for use when we actually render the html where the 
      // social media links live
      window.socialURL = encodedURL;
    });
  };
  var _getBitly = function (long_url, func) {
    var access_token = '76cd85b016e8bd7a08db6ed187302c4ad8da70f2';

    $.getJSON(
      'https://api-ssl.bitly.com/v3/shorten?callback=?',
      {
        'format': 'json',
        'access_token': access_token,
        'longUrl': long_url
      },
      function (response) {
        func(response.data.url);
      }
    );
  };
  var _refreshSelect = function ($selects) {
    $selects.each(function () {
      var $select = $(this);

      $select.selectbox('detach');
      // $select.selectbox();
      // $select.css("display", "none");
    });
  };
  /*
     * Initializes the Driving Directions form. Populates State menu. On form submit,
     * the starting address values are concatenated and passed to the data query method
     * via the "locator:submitDirectionsQuery" event.
     */
  var _initDirectionsForm = function () {
    var n = site.locator.nodes;

    n.dirSubmit.on('click', function (evt) {
      var args = {
        startAddress: n.dirAddrInput.val() + ', ' + n.dirCityInput.val() + ' ' + n.dirStateMenu.val()
      };
      var doorId = n.dirDoorInput.val();

      args.doorData = $('.directions_link').eq(doorId).data('doorData');

			 $('.directions_link').eq(doorId).data('doorData');
      $(document).trigger('locator.submitDirectionsQuery', [args]);
    });
    // populate State menu from JSON data in page
    _clearMenu(site.locator.nodes.dirStateMenu);
    for (var state in site.locator.locationData) {
      generic.forms.select.addOption({
        menuNode: site.locator.nodes.dirStateMenu,
        value: state
      });
    }
  };
  /*
     * Event handler for click of Doors search button
     */
  var _searchClickHandler = function (e) {
    // Hide previously shown errors
    // site.locator.nodes.errorNodes.addClass('inactive');

    // var search = jQuery.trim(site.locator.nodes.searchInput.val());
    var country = site.locator.nodes.countryMenu.val() || site.locator.nodes.localcountryMenu.val();
	  var city = site.locator.nodes.cityMenu.val();
    // var isUS = site.locator.nodes.countryMenu.val().match(/^united states*/i) ? true : (!country || !country.length) ? true : false;
    var distance = site.locator.nodes.distanceMenu.val();
    // get current content from main search text field, and run it through the geocoder
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ 'address': city }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
		   _searchBaseHandler(results[0].geometry.location.lat(), results[0].geometry.location.lng(), distance, city);
        site.locator.addressDisplayData = results[0].formatted_address;
        site.locator.foundLocationData = results;
        site.locator.remainingLocationData = results.slice(1);
      }
    });
  };
  var _scrollPageOnError = function (e) {
    var whereIsErrorTag = site.locator.nodes.locatorErrors.offset().top;

    if ($(window).scrollTop() > whereIsErrorTag) {
      $('html,body').animate({ scrollTop: whereIsErrorTag }, 400);
    }
  };
  var _searchGeoClickHandler = function (e) {
    site.geo.locate(function (args) {
      var door = site.locator.nodes.doorMenu.val();
      var distance = site.locator.nodes.distanceMenu.val();
      var queryArgs = {
        params: [
          {
            'fields': site.locator.queryFields,
            'radius': distance
          }
        ]
      };

      queryArgs.params[0].latitude = args.lat;
      queryArgs.params[0].longitude = args.lng;
      queryArgs.params[0].region_id = site.locator.nodes.localRegionIds.val();

      var storeList = [];

      if (!!door) {
        if (door.length > 0) {
          storeList[0] = door;
          queryArgs.params[0].show_stores_list = storeList;
        }
      }

      // find the containing zip code, then send the query
      var geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(queryArgs.params[0].latitude, queryArgs.params[0].longitude);

      geocoder.geocode({ 'latLng': latlng }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          (function () {
            for (var i = 0; i < results.length; i += 1) {
              for (var j = results[i].address_components.length - 1; j >= 0; j -= 1) {
                if (results[i].address_components[j].types.length === 1 && results[i].address_components[j].types[0] === 'postal_code') {
                  _searchBaseHandler(args.lat, args.lng, site.locator.nodes.distanceMenu.val());
                  // site.locator.queryArgs = queryArgs;
                  site.locator.addressDisplayData = results[i].address_components[j].long_name;

                  return;
                }
              }
            }
          }());
        } else {
          // set some sort of fail status
        }
      });
    });
  };
  var _searchBaseHandler = function (lat, lng, distance, city) {
    var searchcity = null;

	  if (site.locator.nodes.cityLocalize.val().trim() && city) {
		  var citylocaldata = site.locator.nodes.cityLocalize.val().split(',');

		  searchcity = citylocaldata[citylocaldata.indexOf(city) + 1];
    } else {
		  searchcity = city;
    }

	  if (site.locator.nodes.locallanguage.val()) {
      var queryArgs = {
        params: [
          {
            'fields': site.locator.queryFields,
            'radius': distance || site.locator.nodes.distanceMenu.val(),
            'city': searchcity,
            'latitude': lat,
            'longitude': lng,
		  'country_all': $('#local_countries').val(),
		  'language_id': site.locator.nodes.locallanguage.val()
          }
        ],
        callback: function () {
          site.locator.ui.displayResultsTable();
          site.locator.ui.displayMap();
          // site.locator.ui.buildEmailResults();
        }
      };
	  } else {
	  var queryArgs = {
        params: [
          {
            'fields': site.locator.queryFields,
            'radius': distance || site.locator.nodes.distanceMenu.val(),
            'city': searchcity,
            'latitude': lat,
            'longitude': lng,
		  'country_all': $('#local_countries').val()
          }
        ],
        callback: function () {
          site.locator.ui.displayResultsTable();
          site.locator.ui.displayMap();
          // site.locator.ui.buildEmailResults();
        }
      };
	  }
    $(document).trigger('locator.submitSearchQuery', [queryArgs]);
    site.locator.queryArgs = queryArgs;
  };

  site.locator.searchClickHandler = _searchClickHandler;
  /*
     * Event handler for click of close panel button
     */
  var _closePanelClickHandler = function () {
    site.locator.nodes.dirResults.html('');
    site.locator.nodes.dirForm.removeClass('hidden');
  };
  /*
   * Collects parameters from form input elements, packs them into parameters,
   * then passes them to search query via the "locator:submitSearchQuery" event.
   * @see site.locator.data.submitQuery
   */
  var _submitQuery = function (e) {
    var urlParams = e;
    var country = decodeURIComponent(urlParams['country']),
      search_value = $('input.search_input').val();

    // Update users currect URL without reloading page
    window.history.pushState('object or string', 'Title', '/store_locator?searchType=domestic&country='
        + country.split(' ').join('+') + '&search=' + search_value.split(' ').join('+'));

    // Construct URL for sharing
    var share_url = 'http://' + window.location.host + '/store_locator?searchType=domestic&country='
        + country.split(' ').join('+') + '&search=' + search_value.split(' ').join('+');

    _placeShareURL(share_url);

    $('.error').removeClass('error');

    var data = {};
    var door = site.locator.nodes.doorMenu.val();
    /* if(site.locator.nodes.countryMenu.val() === '') { // if local search
      if ((zip && zip.length < 5) && !site.locator.hasCurrentLocation && (city === '')) {
        if(state === '') {
          if (zip === '') {
            generic.showErrors([{text : $('#insufficient_query_data').val()}], site.locator.nodes.locatorErrors);
          } else {
            generic.showErrors([{text : site.locator.nodes.invalidZip.text()}], site.locator.nodes.locatorErrors);
            site.locator.nodes.zipInput.addClass('error');
          }
        } else {
          generic.showErrors([{text : site.locator.nodes.missingCityUS.text()}], site.locator.nodes.locatorErrors);
          site.locator.nodes.cityMenu.addClass('error');
        }
        $("input.zip").val(zip.replace(/[^a-z0-9]/gi, ''));
        site.locator.nodes.storeResults.html('');
        return;
      }
    }
    $("input.zip").val(zip);*/
    var distance = $('select.distance').val();
    var queryArgs = {
      params: [
        {
          'fields': site.locator.queryFields,
          'radius': distance,
          'show_stores_list': 'all',
          'uom': site.locator.unitOfMeasure
        }
      ]
    };
    var localCountry = site.locator.nodes.localcountryMenu.val();
    var intl_city = intlCityURL || site.locator.nodes.cityMenuIntl.val();

    if (country !== '') {
      queryArgs.params[0].state = country;
      queryArgs.params[0].city = intl_city;
      queryArgs.params[0].intlSearch = 1;
      if (site.locator.nodes.intllocalRegionIds.val()) {
        queryArgs.params[0].region_id = site.locator.nodes.intllocalRegionIds.val();
      }
      // start intl search
      // wrap in Google geocode service to get lat/long values needed for v3 requests
      var addresses = intl_city + ', ' + country;
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({ 'address': addresses }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          site.locator.geometry = results[0].geometry;

          queryArgs.params[0].latitude = site.locator.geometry.location.lat();
          queryArgs.params[0].longitude = site.locator.geometry.location.lng();

          // if we have location data, add to request
          var mobileLatitude = site.locator.currentLocationData && (city === '') ? site.locator.currentLocationData.latitude : null;
          var mobileLongitude = site.locator.currentLocationData && (city === '') ? site.locator.currentLocationData.longitude : null;
          var isRangeBtn = $(e.target).hasClass('range-btn');

          site.locator.rangeCheck = isRangeBtn;

          if (site.locator.hasCurrentLocation && (mobileLatitude && mobileLongitude) && !site.locator.rangeCheck && !zip) {
            queryArgs.params[0].latitude = mobileLatitude;
            queryArgs.params[0].longitude = mobileLongitude;
          }
          site.locator.queryArgs = queryArgs;
          queryArgs.callback = function () {
            site.locator.ui.displayResultsTable();
            // site.locator.ui.buildEmailResults();
          };

          $(document).trigger('locator.submitSearchQuery', [queryArgs]);
        }
      });
      // end intl search
    } else {
      country = localCountry;

      // start local search
      // if country is shown but not state, try to grab state from location data.
      if ((country !== '') && (state === '')) {
        for (var state_s in site.locator.locationData[country]) {
          for (var c in site.locator.locationData[country][state_s]) {
            if (c === city) {
              state = state_s;
            }
          }
        }
      }

      // if country AND state are not shown, try to grab state from location data.
      if ((country === '') && (state === '')) {
        for (var country_c in site.locator.locationData) {
          if (country_c == '') {
            continue;
          }
          if (site.locator.defaultCountries.indexOf(country_c) !== -1) {
            for (var state_s in site.locator.locationData[country_c]) {
              for (var c in site.locator.locationData[country_c][state_s]) {
                if (c === city) {
                  state = state_s;
                  country = country_c;
                }
              }
            }
          }
        }
      }

      // add country if not populated and there's only one local country
      if ((country === '') && (site.locator.defaultCountries.split(',').length === 1)) {
        country = site.locator.defaultCountries;
      }

      // wrap in Google geocode service to get lat/long values needed for v3 requests
      var addresses = (city !== '') && (state !== '') ? city + ' ' + state :
        (city !== '') && (country !== '') ? city + ' ' + country :
        state !== '' ? state : '';

      // If we only have a zipcode, it's supposed to be for the US *or* Canada, match the zip against the county postal
      // code format and add the country name to our search to help Google give us a good location.
      if (addresses === '' && zip !== '') {
        var zipUS = /^\d{5}(-\d{4})?$/g;

        if (zipUS.test(zip)) {
          addresses = zip + ', United States';
        }
        var zipCA = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/g;

        if (zipCA.test(zip)) {
          addresses = zip + ', Canada';
        }
      }

      if (addresses === '') {
        addresses = site.locator.defaultCountries.split(',')[0];
      }
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({ 'address': addresses }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          // Google *attempted* to find a location based on what we sent it, but it might have found something *else* that seemed
          // to match instead. Only accept a match if the location meets our criteria (zip, city & state, or city & country)
          if (!site.locator.hasCurrentLocation) {
            var match = -1;

            for (var i = 0; i < results.length; i++) {
              var matchZip = false;
              var matchCity = false;
              var matchState = false;
              var matchCountry = false;

              for (var j = 0; j < results[i].address_components.length; j++) {
                var thisComp = results[i].address_components[j];

                // Matched on zip
                if (zip && thisComp.types[0] == 'postal_code' && thisComp.short_name == zip) {
                  matchZip = true;
                }
                if (city && thisComp.types[0] == 'locality' && thisComp.short_name == city) {
                  matchCity = true;
                }
                if (state && thisComp.types[0] == 'administrative_area_level_1' && thisComp.short_name == state) {
                  matchState = true;
                }
                if (country && thisComp.types[0] == 'country' && thisComp.short_name == country) {
                  matchCountry = true;
                }
              }
              if (matchZip || (matchCity && matchState) || (matchCity && matchCountry)) {
                match = i;
                break;
              }
            }
            if (match == -1) {
              generic.showErrors([{ text: site.locator.nodes.invalidZip.text() }], site.locator.nodes.locatorErrors);
              site.locator.nodes.searchInput.addClass('error');
              site.locator.nodes.storeResults.html('');

              return;
            }
            site.locator.geometry = results[match].geometry;
            queryArgs.params[0].latitude = site.locator.geometry.location.lat();
            queryArgs.params[0].longitude = site.locator.geometry.location.lng();
          }
          queryArgs.params[0].country = country;
          queryArgs.params[0].zip = zip;
          queryArgs.params[0].state = state;
          queryArgs.params[0].city = city;
          queryArgs.params[0].intlSearch = 0;
          queryArgs.params[0].region_id = site.locator.nodes.localRegionIds.val();
          var storeList = [];

          if (door.length > 0) {
            storeList[0] = door;
            queryArgs.params[0].show_stores_list = storeList;
          }

          // if we have location data, add to request
          var mobileLatitude = site.locator.currentLocationData && (city === '') ? site.locator.currentLocationData.latitude : null;
          var mobileLongitude = site.locator.currentLocationData && (city === '') ? site.locator.currentLocationData.longitude : null;
          var isRangeBtn = $(e.target).hasClass('range-btn');

          site.locator.rangeCheck = isRangeBtn;

          if (site.locator.hasCurrentLocation && (mobileLatitude && mobileLongitude) && !site.locator.rangeCheck && !zip) {
            queryArgs.params[0].latitude = mobileLatitude;
            queryArgs.params[0].longitude = mobileLongitude;
            // uncoment below to see location sensor work when local country isn't the United States
            // queryArgs.params[0].country = "United States";
            // queryArgs.params[0].region_id = "1";
          }
          queryArgs.callback = function () {
            site.locator.ui.displayResultsTable();
            // site.locator.ui.buildEmailResults();
          };
          site.locator.queryArgs = queryArgs;

          $(document).trigger('locator.submitSearchQuery', [queryArgs]);
        } else { // google geocode lookup failed
          if (addresses.indexOf(zip) === 0) { // geocode failed because of bad zip/postal code
            generic.showErrors([{ text: site.locator.nodes.invalidZip.text() }], site.locator.nodes.locatorErrors);
            site.locator.nodes.searchInput.addClass('error');
            site.locator.nodes.storeResults.html('');
          }
        }
      });
      // end local search
    }
  };

  _initDirectionsForm();
  _initMenus();

  site.locator.nodes.countryMenu.on('change', function (e) {
    _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
  });

  site.locator.nodes.searchBtn.on('click', function (e) {
    _searchClickHandler(e);
  });
  site.locator.nodes.searchGeoBtn.on('click', function (e) {
    _searchGeoClickHandler(e);
  });
  site.locator.nodes.closePanel.on('click', function () {
    $(this).hide();
    _closePanelClickHandler();
  });
};

/*
 * This function fetches the JS template: /templates/locator/location_info.tmpl
 * and uses it to create the info windows that are displayed when clicking on a pointer image on the map.
 */
site.locator.ui.buildLocationHtml = function (args) {
  generic.template.get({
    path: '/templates/locator/location_info.tmpl',
    object: args.locationData,
    callback: function (html) {
      args.callback(html);
    }
  });
};

// Build the html that we will pass to the email handler for results
site.locator.ui.buildEmailResults = function () {
  var embody = null;
  var buildRow = function (doorData, idx) {
    doorData.index_number = idx;

    generic.template.get({
      path: '/templates/locator/door_row_email.tmpl',
      object: doorData,
      callback: function (html) {
        var idx = doorData.index_number;
        var node = $(html);

        embody.append(node);
      }
    });
  };

  generic.template.get({
    path: '/templates/locator/doors_table_email.tmpl',
    callback: function (html) {
      $('#email_results').empty();
      embody = site.locator.nodes.emailNode;
      var i = 0;

      for (var d in site.locator.resultData.results) {
        buildRow(site.locator.resultData.results[d], i);
        i++;
      }
    }
  });
};

/*
 * This function builds the table of result data. It loads the JS template: /templates/locator/door_row.tmpl.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayResultsTable = function () {
  if ((typeof site.locator.resultData.count === 'undefined') || (site.locator.resultData.count === 0)) {
    site.locator.nodes.storeResults.html('');
    generic.showErrors([{ text: site.locator.nodes.noLocationsFound.val() }], site.locator.nodes.locatorErrors);

    return;
  }
  var tbody = null;
  var buildRow = function (doorData, idx) {
    doorData.index_number = idx;
    doorData.display_number = idx + 1;
    doorData.precision_distance = parseFloat(doorData.DISTANCE).toFixed(2) + (site.locator.unitOfMeasure === 'mile' ? ' miles' : ' km');
    doorData.precision_distance = isNaN(doorData.precision_distance) ? '' : doorData.precision_distance;
    doorData.CITY_STATEPROV = doorData.CITY + ', ' + doorData.STATE_OR_PROVINCE;
    doorData.ADDRESSURL = (doorData.ADDRESS + ' ' + doorData.ADDRESS2 + ', ' + doorData.CITY_STATEPROV).replace(/ /g, '+');
    doorData.PHONEURL = doorData.PHONE1.replace(/ /g, '-');
    doorData.ADDRESS2 = doorData.ADDRESS2 != '' ? doorData.ADDRESS2 + '<br />' : '';

    if (doorData.EVENT_START_DATE && doorData.EVENT_END_DATE) {
      var event_start = new Date(doorData.EVENT_START_DATE.replace(/-/g, ' '));
      var event_end = new Date(doorData.EVENT_END_DATE.replace(/-/g, ' '));

      // PBruno: the check for the year has to  do with JS 1.2 backwards compatibility,
      // which would in some instances spit out a four-digit full year, for all
      // years not in 1900-1999; I just check for any four digit value for year,
      // and if I find one, leave it alone (forego adding the 1900)
      doorData.EVENT_DATE = event_start.getMonth() + 1 + '/' + event_start.getDate() + '/' + (event_start.getYear() < 1000 ? parseInt(event_start.getYear()) + 1900 : event_start.getYear());
      doorData.EVENT_DATE += ' - ';
      doorData.EVENT_DATE += event_end.getMonth() + 1 + '/' + event_end.getDate() + '/' + (event_end.getYear() < 1000 ? parseInt(event_end.getYear()) + 1900 : event_end.getYear());

      var hasEvent = true;
    }

    generic.template.get({
      path: '/templates/locator/door_row.tmpl',
      object: doorData,
      callback: function (html) {
        var doorRow = $(html);

        if (idx >= 10) {
          doorRow.addClass('hidden');
        }
        doorRow.find('.store_name a').on('click', function () {
          site.locator.ui.launchInfoWindow(idx);
          $('html,body').animate({ scrollTop: site.locator.nodes.mapContainer.offset().top }, 400);
        });
        doorRow.find('.event-details a.view-details').on('click', function (e) {
          e.preventDefault();
          generic.template.get({
            path: '/templates/locator/doors_event_popup.tmpl',
            object: doorData,
            callback: function (html) {
              var content = $(html);

              content.filter('.event-large-image').error(function () {
                $(this).css('display', 'none');
              });
              content.filter('.close-link').on('click', function() {
                generic.overlay.hide();
              });
              generic.overlay.launch({
                content: content,
                includeBackground: true,
                includeCloseLink: false,
                hideOnClickOutside: true,
                center: false,
                cssClass: 'store-locator-mobile-popup-v1',
                cssStyle: {
                  width: '100%',
                  padding: '10px',
                  top: ($(document).scrollTop() + 35) + 'px',
                  left: '0px'
                }
              });
              addthisevent.refresh(); // Refresh 'Add To Calendar' 
            }
          });
        });
        site.locator.nodes.doorRows.push(doorRow);
        if (hasEvent) {
          site.locator.nodes.doorWithEventRows.push(doorRow);
        } else {
          doorRow.find('.event-details').css('display', 'none');
          site.locator.nodes.doorWithoutEventRows.push(doorRow);
        }
        tbody.append(doorRow);
      }
    });
  };

  generic.template.get({
    path: '/templates/locator/doors_table.tmpl',
    callback: function (html) {
      site.locator.nodes.storeResults.html(html);

      // Clone the contents of the print-and-share div to print-and-share2
      $('.print-and-share').clone().appendTo('.print-and-share2');
      var isEmail = function (email) {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        return regex.test(email);
      };

      if (site.locator.queryArgs.params !== undefined && site.locator.queryArgs.params.length) {
        var params = site.locator.queryArgs.params[0],
          searchCriteria = [],
          paramKeys = ['zip', 'state', 'city'];

        for (var i = 0; i < paramKeys.length; i++) {
          var paramKey = paramKeys[i];

          if (params[paramKey] !== undefined) {
            searchCriteria.push(params[paramKey]);
          }
        }
        // Logic to make the displayed search query look pretty. Remove + signs if this came from a URL search
        var searchQuery;

        if (site.locator.queryArgs.params[0].country) {
          site.locator.queryArgs.params[0].country = site.locator.queryArgs.params[0].country.split('+').join(' ');
        }
        if (site.locator.queryArgs.params[0].state) {
          site.locator.queryArgs.params[0].state = site.locator.queryArgs.params[0].state.split('+').join(' ');
        }
        if (site.locator.queryArgs.params[0].city) {
          site.locator.queryArgs.params[0].city = site.locator.queryArgs.params[0].city.split('+').join(' ');
        }
        if (site.locator.queryArgs.params[0].intlSearch) {
          searchQuery = site.locator.queryArgs.params[0].city + ', ' + site.locator.queryArgs.params[0].state;
        } else {
          if (site.locator.queryArgs.params[0].zip) {
            searchQuery = 'Zipcode ' + site.locator.queryArgs.params[0].zip;
          } else {
            searchQuery = site.locator.queryArgs.params[0].city + ', ' + site.locator.queryArgs.params[0].state;
          }
        }

        window.searchQuery = searchQuery;
      }

      var totalResults = site.locator.resultData.results,
        $resultCountNode = totalResults === 1 ? $('.results-count-singular') : $('.results-count-plural');

      $resultCountNode.siblings('.header-content').remove();
      $resultCountNode.clone()
        .html($resultCountNode.text().replace('::count::', '<span class="count">' + totalResults + '</span>').replace('::query::', '<span class="query">' + site.locator.addressDisplayData + '</span>'))
        .removeClass()
        .addClass('header-content')
        .appendTo($resultCountNode.parent());

      tbody = site.locator.nodes.storeResults.find(site.locator.nodes.doorsBodySel);
      // resultData.results.each( function(doorID, idx) {
      //     buildRow(locations[doorID], idx);
      // });
      for (var i = 0; i < site.locator.resultData.sortedResults.length; i += 1) {
        buildRow(site.locator.resultData.sortedResults[i], i);
      }
      if (i >= 10) {
        site.locator.nodes.moreResultsContainer.removeClass('hidden');
        site.locator.nodes.moreResultsButton.on('click', function(e) {
          e.preventDefault();
          $('.door_row.hidden').removeClass('hidden');
          $('.map-marker.hidden').removeClass('hidden');
          site.locator.nodes.moreResultsContainer.addClass('hidden');
        });
      }
    }
  });
  $('html,body').animate({ scrollTop: site.locator.nodes.storeResults.offset().top + 'px' }, 'fast');
};

/*
 * Convenience funtion that builds the path to custom pointer images.
 * Images should be named map_marker_[capital letter].png and placed in /images/locator.
 * @returns {string} relative path to image, e.g., /images/locator/map_marker_B.png
 */
site.locator.ui.getMarkerImagePath = function (num) {
  var ltr = String.fromCharCode('A'.charCodeAt(0) + num);

  return generic.env.domain + '/images/locator/map_marker_' + ltr + '.png';
};

/*
 * This function encapsulates the various calls to the Google Maps API that render
 * the map of results. It initializes a google.maps.Map object (storing it in site.locator.map),
 * adds markers, and sets up the event handler for clicking on the markers.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayMap = function () {
  site.locator.nodes.mapContainer.removeClass('hidden');

  var mapOptions = {
    zoom: 10,
    center: new google.maps.LatLng(site.locator.resultData.latitude, site.locator.resultData.longitude),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: false,
    navigationControl: true,
    mapTypeControl: false,
    scaleControl: true
  };
  var map = new google.maps.Map(site.locator.nodes.map[0], mapOptions);

  site.locator.map = map;

  var idx = 0;

  for (var d in site.locator.resultData.sortedResults) {
    if (idx > 20) {
      break;
    }
    //
    // place markers on Google Map
    var location = site.locator.resultData.sortedResults[d];
    var lat = location.LATITUDE;
    var lng = location.LONGITUDE;
    var latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
    var marker = site.locator.MapLocationIcon({
      id: '',
      latlng: latLng,
      label: idx + 1,
      icon_class: idx >= 10 ? 'hidden' : '',
      map: map,
      clickHandler: (function (idx) {
        return function () {
          site.locator.ui.launchInfoWindow(idx);
        };
      }(idx))
    });

    site.locator.markers[idx] = marker;
    //
    // build info window
    site.locator.ui.buildLocationHtml({
      locationData: location,
      callback: function (html) {
        site.locator.locationsHtml[idx] = html;
        //
        // display info window on first location
        if (idx == 0) {
          site.locator.ui.launchInfoWindow(idx);
        }
      }
    });

    //
    // launch info window on click of marker (on map)
    google.maps.event.addListener(marker, 'click', function (e) {
      site.locator.ui.launchInfoWindow(idx);
    });
    //
    // set map center for first location
    if (idx == 0) {
      site.locator.map.setCenter(latLng);
    }
    idx++;
  }
};

/*
 * Displays Info Window for a given marker/door.
 * @param i {Number} index of door/marker for which info window should be displayed
 */
site.locator.ui.launchInfoWindow = function (i) {
  if (!site.locator.infoWindow) {
    site.locator.infoWindow = new google.maps.InfoWindow({ pixelOffset: new google.maps.Size(0, -44) });
  }
  site.locator.infoWindow.setContent(site.locator.locationsHtml[i]);
  site.locator.infoWindow.open(site.locator.map, site.locator.markers[i]);
};

/*
 * Callback function for "locator:directionsLoaded" event.
 * Hides Directions form and displays Directions results table.
 * Passes directions query response to google.maps.DirectionsRenderer object.
 * @param response {Object} response from Google Maps directions query
 */
site.locator.ui.displayDirections = function (response) {
  site.locator.nodes.dirForm.addClass('hidden');
  site.locator.nodes.dirResults.removeClass('hidden');
  site.locator.directionsDisplay.setDirections(response);
};

site.locator.util = {};
site.locator.util.fixDate = function (date) {
  if (date == null) {
    return;
  }

  if (typeof date != 'undefined') {
    date = date.split(' ')[0];
  } else {
    date = 'XX-XXX-XXXX';
  }
  var dateParts = date.split('-');

  return dateParts[1] + ' ' + dateParts[0] + ', ' + dateParts[2];
};

site.locator.run = function () {
  site.locator.getDomNodes();
  site.locator.ui.getRBs();
  site.locator.ui.init();
  site.locator.ui.getTemplates();
};

site.locator.searchOnURL = function () {
  var href = document.URL;
  var hashObject = {
    'searchType': null,
    'country': null,
    'city': null,
    'state': null,
    'zip': null
  };

  if (href === undefined || href === null) {
    return;
  }
  var index = href.indexOf('?');

  if (index < 0) {
    return hashObject;
  }
  var hash = href.substr(index + 1);
  var hashArray = hash.split('&');

  for (var i = 0; i < hashArray.length; i++) {
    parameter = hashArray[i].split('=');
    if (parameter.length == 2) {
      hashObject[parameter[0]] = parameter[1];
    } else {
      hashObject[parameter[0]] = parameter[0];
    }
  }

  if (hashObject['searchType']) {
    site.locator.searchClickHandler(hashObject);
  }

  return;
};

$(document).ready(function () {
  // site.locator.run()
  site.locator.run();
  site.locator.searchOnURL();
}); // end dom:loaded

$(document).on('locator.directionsLoaded', function (e, param) {
  site.locator.ui.displayDirections(param);
});

/*
 * This function handles the query submit event. It parses the data from the event memo
 * and passes it to the fetch method. This method should NOT be called directly by a UI method;
 * rather, the params should be passed as part of the memo to the locator:submitSearchQuery event.
 * @param {function} args.callback a function that gets called after door data is returned
 * @param {Array} args.params an Array that contains a hash of parameters that get
 * passed to the JSON-RPC method.
 * @param {Array} args.params[0].fields The data fields to be returned from the JSON-RPC request
 * @param {number} args.params[0].radius The distance from the origin point inside which stores should be returned.
 * @param {string} args.params[0].zip Postal Code of origin point location
 * @param {string} args.params[0].state State of origin point location
 * @param {string} args.params[0].city City of origin point location
 * @param {Array} args.params[0].show_stores_list Array of Store Names by which results should be filtered. Empty array
 * should be passed to return all stores.
 * @example
 * // var queryArgs = {
 * //     params : [{
 * //         fields : "DOOR_ID, DOORNAME, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY",
 * //         radius : 25,
 * //         zip    : "10014",
 * //         state  : "NY",
 * //         city   : "New York"
 * //     }],
 * //     callback : function() {
 * //          site.locator.ui.displayMap();
 * //          site.locator.ui.displayResultsTable();
 * //      }
 * // };
 */
site.locator.data.submitQuery = function (args) {
  $('.error').removeClass('error');

  var params = args.params;
  var callbackFn = args.callback;

  // new error
  /* if (params[0].intlSearch) {
    if (params[0].state && !params[0].city) {
      site.locator.nodes.cityMenuIntl.addClass('error');
      generic.showErrors([{text : site.locator.nodes.missingCityIntl.text()}], site.locator.nodes.locatorErrors);
      site.locator.nodes.storeResults.html('');
      return;
    }
  } else {
    if (params[0].state) {
      if (!params[0].city) {
        if (params[0].zip) {
          params[0].state = '';
        } else {
          generic.showErrors([{text : site.locator.nodes.missingCityUS.text()}], site.locator.nodes.locatorErrors);
          site.locator.nodes.storeResults.html('');
          return;
        }
      } else {
        params[0].zip = '';
      }
    } else {
      if ((params[0].zip.length < 5) && !site.locator.hasCurrentLocation && (params[0].city === '')) {
        generic.showErrors([{text : site.locator.nodes.invalidZip.text()}], site.locator.nodes.locatorErrors);
        site.locator.nodes.storeResults.html('');
        return;
      };
    }
  }*/
  site.locator.data.fetch({
    data: params,
    onSuccess: function (resultData) {
      resultData.maxDistance = parseFloat(args.params[0].radius);
      if (isNaN(resultData.maxDistance)) {
        resultData.maxDistance = null;
      }
		   var filteredResults1 = {};
      var doorid_list = [];
      var point = 0;
      var startDate, endDate;

      for (var dd in resultData.results) {
        var selectedcountry = site.locator.defaultCountries;

        if (resultData.results[dd].COUNTRY == selectedcountry) {
          startDate = resultData.results[dd].EVENT_START_DATE;
          endDate = resultData.results[dd].EVENT_END_DATE;
          if (startDate != null && endDate != null) {
            resultData.results[dd].EVENT_START_DATE = startDate.split(' ')[0];
            resultData.results[dd].EVENT_END_DATE = endDate.split(' ')[0];
          }
          filteredResults1[dd] = resultData.results[dd];
          doorid_list[point] = dd;
          point++;
        }
      }
      resultData.results = filteredResults1;
      resultData.doors = doorid_list.sort();
      site.locator.data.setData(resultData);
      if (typeof callbackFn === 'function') {
        callbackFn();
      }

      jQuery.each(site.locator.nodes.errors, function () {
        this.addClass('inactive');
      });
      if (resultData.count === 0) {
        site.locator.nodes.errors.noStoresFound.removeClass('inactive');
      }
    },
    onFailure: function (jsonRpcResponse) {
      var errorObjectsArray = jsonRpcResponse.getMessages();

      jQuery.each(site.locator.nodes.errors, function () {
        this.addClass('inactive');
      });
      site.locator.nodes.errors.noStoresFound.removeClass('inactive');

      site.locator.nodes.storeResults.html('');
    }
  });
  // end new error

  // temporary front-end validation to verify that zip input exists. should eventually be checked on the backend.
  /*
    if( params[0].zip || site.locator.hasCurrentLocation || ((params[0].city + params[0].state + params[0].show_stores_list[0]) !== '')) {
      site.locator.data.fetch({
          data: params,
          onSuccess: function(resultData) {
              if(resultData.count > 0) {
                resultData.maxDistance = parseFloat(args.params[0].radius);
                if (isNaN(resultData.maxDistance) ) {
                    resultData.maxDistance = null;
                }
                  site.locator.data.setData(resultData);
                if (typeof callbackFn === "function") {
                    callbackFn();
                }
                generic.showErrors([], site.locator.nodes.locatorErrors);
              } else {
                //var errorObjectsArray = need to get the equivalent of jsonRpcResponse.getmessages(), but for successful searches.
                //generic.showErrors(errorObjectsArray, site.locator.nodes.locatorErrors);
                //need to find proper solution. in the meantime...
                errorObj = {};
                errorObj.key = 'error';
                errorObj.text = $('#no_locations_found').val();
                if(params[0].intlSearch === 1){
                  errorObj.text = $('#select_city').val();
                  site.locator.nodes.cityMenuIntl.addClass('error');
                }else if ((params[0].zip === '') && (params[0].state !== '') && (params[0].city === '')){
                  errorObj.text = $('#select_city').val();
                  site.locator.nodes.cityMenu.addClass('error');
                }
                generic.showErrors([errorObj], site.locator.nodes.locatorErrors);
              }

          },
          onFailure: function(jsonRpcResponse) {
              var errorObjectsArray = jsonRpcResponse.getMessages();
              if(errorObjectsArray[0].key === 'insufficient_query_data'){
                errorObjectsArray[0].text = $('#insufficient_query_data').val();
              }
              generic.showErrors(errorObjectsArray, site.locator.nodes.locatorErrors);
          }
      });

      // populate directions state menu drop down with inital state select options (until issue with original implementation is discovered)
      site.locator.nodes.dirStateMenu.html(site.locator.nodes.stateMenu.eq(0).html());
    } else {
      var errorObj = {};
      errorObj.key = 'insufficient_query_data';
      errorObj.text = $('#insufficient_query_data').val();
      generic.showErrors([errorObj], site.locator.nodes.locatorErrors);
      site.locator.nodes.zipInput.addClass('error');
      site.locator.nodes.stateMenu.addClass('error');
      site.locator.nodes.cityMenu.addClass('error');
    }
    
    */
};

$(document).on('locator.submitSearchQuery', function (evt, param) {
  site.locator.data.submitQuery(param);
});

/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.fetch = function (args) {
  generic.jsonrpc.fetch({
    method: 'locator.doorsandevents',
    params: args.data,
    onSuccess: function (r) {
      var resultData = r.getValue();

      args.onSuccess(resultData);
    },
    onFailure: function (r) {
      args.onFailure(r);
    }
  });
};

/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.setData = function (rawResultData) {
  site.locator.resultData = rawResultData;
  if (rawResultData.maxDistance) { // max distance exists
    var filteredResults = {};

    for (var d in rawResultData.results) {
      if (rawResultData.results[d].DISTANCE < rawResultData.maxDistance) {
        filteredResults[d] = rawResultData.results[d];
      }
    }
    site.locator.resultData.results = filteredResults;
  }
  // asc. sort by distance
  var sortedResults = [];
  var r = site.locator.resultData.results;
  var doors = site.locator.resultData.doors || [];
  var sortedDoorIds = doors.sort(function (d) {
    return parseFloat(r[d]);
  });

  for (var i = 0, len = sortedDoorIds.length; i < len; i++) {
    sortedResults.push(site.locator.resultData.results[sortedDoorIds[i]]);
  }
  site.locator.resultData.sortedResults = sortedResults;
};

/*
 * This function retrieves Driving Directions data from Google. The data
 * retrieved is then passed as a memo in the event "locator:directionsLoaded."
 */
site.locator.data.getDirections = function (args) {
  site.locator.nodes.closePanel.show();
  var directionsService = new google.maps.DirectionsService();

  site.locator.directionsDisplay = new google.maps.DirectionsRenderer();

  site.locator.directionsDisplay.setMap(site.locator.map);
  site.locator.directionsDisplay.setPanel(site.locator.nodes.dirResults[0]);

  var start = args.startAddress;
  var end = args.doorData.ADDRESS + ', ' + args.doorData.CITY;
  var request = {
    origin: start,
    destination: end,
    travelMode: google.maps.DirectionsTravelMode.DRIVING
  };

  directionsService.route(request, function (response, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      $(document).trigger('locator.directionsLoaded', [response]);
    } else {
      alert('Please enter a valid starting address.');
    }
  });
};
$(document).on('locator.submitDirectionsQuery', function (evt, param) {
  site.locator.data.getDirections(param);
});
